import { useMarketByAddress } from './types/MarketByAddress'

type Props = {
  fullAddress?: string
}

export default function MarketRules({ fullAddress }: Props) {
  const { data } = useMarketByAddress({
    skip: !fullAddress || !fullAddress.length,
    variables: {
      fullAddress: fullAddress || ''
    }
  })
  const market = data?.marketByAddress

  if (!market) return null

  return (
    <div className="bg-orange-50 py-4 sm:-mx-10 -mx-8 sm:px-10 px-8 mb-4">
      <div className="prose text-black">
        {market.eventsReward.cents > 0 && (
          <p>
            As a bonus, the organizer filling out this application will get{' '}
            {market.eventsReward.formatted} in credits to use towards their
            order.
          </p>
        )}
      </div>
    </div>
  )
}
